import React from 'react';

import { ManagedLeadDetail } from '../../../services/api/managed-leads/managedLeads';
import { formatAdvancementDatum } from '../managedLeadAdvancementData';
import {
  canEditManagedLeadAppointment,
  MANAGED_LEAD_APPOINTMENT_ROWS,
} from '../managedLeadAppointment';
import {
  ManagedLeadDetailDatum,
  ManagedLeadDetailSection,
} from './ManagedLeadDetailSection';
import ManagedLeadSectionEditButton from './ManagedLeadSectionEditButton';

interface ManagedLeadAppointmentBoxProps {
  detail: ManagedLeadDetail;
  onEditPress: () => void;
}

/**
 * The appointment of a managed lead, read from the advancement data the detail
 * already carries so the operator does not have to open an update to see when
 * the customer is being met. Unlike Mutui, the pencil is not a write of its own:
 * Prestiti and CdQ keep the single server-driven stage update, so it opens that
 * form - and only where the form would in fact collect the appointment.
 */
const ManagedLeadAppointmentBox = ({
  detail,
  onEditPress,
}: ManagedLeadAppointmentBoxProps) => (
  <ManagedLeadDetailSection
    title="Appuntamento"
    action={
      canEditManagedLeadAppointment(detail) ? (
        <ManagedLeadSectionEditButton
          label="Modifica appuntamento"
          onPress={onEditPress}
        />
      ) : null
    }
  >
    {MANAGED_LEAD_APPOINTMENT_ROWS.map((row) => (
      <ManagedLeadDetailDatum
        key={row.key}
        label={row.label}
        value={formatAdvancementDatum(
          detail.advancementData,
          row.key,
          row.kind
        )}
      />
    ))}
  </ManagedLeadDetailSection>
);

export default ManagedLeadAppointmentBox;
